import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { PLATFORM_ADMIN, accessRole, canAccessSlug } from '../config/routeAccess.js';

/**
 * Gate for role-restricted routes (use inside a ProtectedRoute). A signed-in user
 * without one of the roles is sent to /403; the page's API endpoints are
 * independently permission-guarded server-side. A platform administrator (an Admin
 * that belongs to no customer) is held to the pages that work without a customer.
 */
export default function RoleRoute({ roles }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (accessRole(user) === PLATFORM_ADMIN && !canAccessSlug(PLATFORM_ADMIN, pathname.split('/')[1])) {
    return <Navigate to="/403" replace />;
  }
  const allowed = roles.map((r) => r.toLowerCase());
  if (!user || !allowed.includes(String(user.role).toLowerCase())) {
    return <Navigate to="/403" replace />;
  }
  return <Outlet />;
}
